"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _icon = _interopRequireDefault(require("../icon"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HelpToolTip = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(HelpToolTip, _React$PureComponent);

  var _super = _createSuper(HelpToolTip);

  function HelpToolTip() {
    (0, _classCallCheck2.default)(this, HelpToolTip);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(HelpToolTip, [{
    key: "render",
    value: function render() {
      var help = this.props.help; // Note: we use disableTouchListener as otherwise the user needs to press and hold before the
      // tooltip appears, something that is not intuitive. With this configuration, the user can just
      // click the button to view the tooltip.

      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        disableTouchListener: true,
        title: help
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        "aria-label": "Help"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "HelpOutline"
      })));
    }
  }]);
  return HelpToolTip;
}(_react.default.PureComponent);

exports.default = HelpToolTip;